<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     搜索内容
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="search-content">
    <div v-loading="loading" class="mt-sm pt-sm pb-sm" :class="{'bg-white': searching || loading }" style="border-radius: 5px;" :style="{ 'border': searching || loading ? '1px solid rgba(220,223,230,1)' : '', 'height': height + 'px'}">
      <el-scrollbar :native="false" class="scrollbar-view box" view-class="el-scrollbar-view" :style="{ height: height - 18 + 'px' }">
        <div style="height:100%;">
          <div v-for="(item, index) in options" :key="index" class="custom-option" @click="selectChange(item)">
            <div class="flex align-items-center">
              <div class="bd">
                <div class="text-bold" :class="{'text-primary': item.creditCode == active_company_code}">{{ item.name }}</div>
                <div class="font-sm mt-xs" :class="{'text-primary': item.creditCode == active_company_code }" style="color: #888;">{{ item.creditCode }}</div>
              </div>
              <div v-if="tick && item.creditCode == active_company_code" class="ft font-2x">
                <div class="text-primary iconfont icon-tick"></div>
              </div>
            </div>
            
          </div>
          <div v-if="searching && !options.length" class="flex-center text-muted">
            无匹配结果
          </div>
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import { companyQueryApi, companyCreateApi } from '@/api/prm/prmApi'

export default {
  name: 'SearchContent',

  components: {
  },

  props: {
    keyword: {
      type: String,
      default: '',
    },

    tick: {
      type: Boolean,
      default: false,
    },

    height: {
      type: Number,
      default: 238,
    }
  },

  data() {
    return {
      loading: false,
      searching: false,
      options: [],
      active_company_code: '',
    }
  },

  computed: {
  },

  created() {
  },

  methods: {
    handleSearch() {
      if (!this.keyword) {
        this.searching = false
        this.options = []
        this.$message.error("请输入公司名称");
        return;
      }
      this.loading = true
      companyQueryApi({ keyword: this.keyword }).then(res => {
        this.searching = true;
        this.loading = false
        if (!res.errno) {
          this.options = res.data
        }
      })
    },

    selectChange(item) {
      companyCreateApi(item).then((res) => {
        if (!res.errno) {
          const clueCompany = Object.assign({}, item, { company_id: res.data.company_id })
          this.active_company_code = item.creditCode
          this.$emit('select', clueCompany)
        } else {
          this.$message.error(res.message);
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  padding: 0;
  .custom-option {
    padding: 8px 16px !important;
    line-height: 1.5 !important;
    cursor: pointer;
    border-bottom: 1px solid rgba(220,223,230,0.3);
    &:hover {
      background-color: #f5f4f6;
    }
  }
}
</style>